import { Spinner as FluentSpinner } from "@fluentui/react-components";

const Spinner = ({ label }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // or a fixed height if needed
        width: "100%",
      }}
    >
      <FluentSpinner label={label} />
    </div>
  );
};

export default Spinner;
